import { render, staticRenderFns } from "./peaChangeCheckNotifications.vue?vue&type=template&id=2d0c3fac&scoped=true"
import script from "./peaChangeCheckNotifications.vue?vue&type=script&lang=js"
export * from "./peaChangeCheckNotifications.vue?vue&type=script&lang=js"
import style0 from "./peaChangeCheckNotifications.vue?vue&type=style&index=0&id=2d0c3fac&prod&lang=css&scoped=true"
import style1 from "./peaChangeCheckNotifications.vue?vue&type=style&index=1&id=2d0c3fac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c3fac",
  null
  
)

export default component.exports